import { usePaymentData } from '@p2p/entities/payment';
import { useParams } from 'react-router-dom';

import { TransferRequestSuccess } from './TransferRequestSuccess';

export const TransferRequestSuccessPage = () => {
  const { id = '' } = useParams<{ id: string }>();
  const { order } = usePaymentData();

  return <TransferRequestSuccess order={order} id={id} />;
};
